import { render, staticRenderFns } from "./BundleIcons.vue?vue&type=template&id=43af71f6&scoped=true"
import script from "./BundleIcons.vue?vue&type=script&setup=true&lang=ts"
export * from "./BundleIcons.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BundleIcons.vue?vue&type=style&index=0&id=43af71f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43af71f6",
  null
  
)

export default component.exports